import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function PricingSection() {
  return <div id="pricing" className="bg-gradient-to-b from-dark-900 to-dark-800 pb-8 md:pb-24 pt-0 md:pt-4" data-id="element-183">
      <Section data-id="element-184">
        {/* Centered title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-cream-100 text-center mb-6 md:mb-10" data-id="element-185">
          ¿Para quién es este
          <br data-id="element-186" />
          Audiolibro + eBook?
        </motion.h2>

        {/* Who is it for */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-12 mb-6 md:mb-24" data-id="element-187">
          <div data-id="element-188">
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.15
          }} className="text-gold-400 text-center md:text-left mb-4 md:mb-8" data-id="element-189">
              Esto es para ti si al menos UNA de estas frases te identifica:
            </motion.p>
            <ul className="space-y-3 md:space-y-4 text-cream-200 text-sm" data-id="element-190">
              {['"Yo viví esto… pero nadie lo explica completo."', '"Me niego a que digan que no fue para tanto."', '"No quiero que dentro de 10 años lo cuenten como si fuera inevitable."'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.25 + i * 0.12
            }} className="flex items-start" data-id="element-191">
                  <CheckIcon className="w-5 h-5 mr-3 text-gold-500 mt-0.5 flex-shrink-0" data-id="element-192" />
                  <span data-id="element-193">{item}</span>
                </motion.li>)}
            </ul>
          </div>
          <div data-id="element-194">
            <motion.h4 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="font-serif text-cream-300 mb-6 text-xl border-b border-dark-600 pb-2 text-center md:text-left mt-4 md:mt-0" data-id="element-195">
              NO es para ti si:
            </motion.h4>
            <ul className="space-y-3 md:space-y-4 text-cream-300/70 text-sm" data-id="element-196">
              {['Buscas entretenimiento ligero.', 'Quieres una versión cómoda.', 'Prefieres no cuestionar lo que escuchas.'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.15 + i * 0.1
            }} className="flex items-start" data-id="element-197">
                  <XIcon className="w-5 h-5 mr-3 text-dark-500 mt-0.5 flex-shrink-0" data-id="element-198" />
                  <span data-id="element-199">{item}</span>
                </motion.li>)}
            </ul>
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 1.0
          }} className="mt-6 md:mt-8 text-cream-100 font-medium text-sm border-t border-dark-700 pt-3 md:pt-4 text-center" data-id="element-200">
              Este libro no adormece. Despierta.
            </motion.p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-201">
          <motion.div id="pricing-cta" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative bg-dark-800 rounded-2xl overflow-hidden border border-gold-500/30 shadow-2xl shadow-gold-900/20" data-id="element-202">
            {/* Decorative top bar */}
            <div className="h-2 w-full bg-gradient-to-r from-gold-600 via-ember-500 to-gold-600" data-id="element-203" />

            <div className="grid md:grid-cols-5 gap-0" data-id="element-204">
              {/* Left side: Value & Context */}
              <div className="md:col-span-3 p-6 md:p-12 border-b md:border-b-0 md:border-r border-dark-700 bg-dark-800/50" data-id="element-205">
                <h3 className="text-2xl md:text-3xl font-serif text-cream-100 mb-6 font-bold leading-tight text-center" data-id="element-206">
                  Por qué cuesta solo{' '}
                  <span className="text-gold-400" data-id="element-207">$9.97</span>
                </h3>

                <p className="text-cream-200/90 text-base md:text-lg mb-6 md:mb-8 leading-relaxed text-center" data-id="element-208">
                  Porque esta información debería estar al alcance del
                  venezolano común para que nadie pueda confundirte cuando
                  intenten venderte la historia a medias.
                </p>

                <div className="space-y-4" data-id="element-209">
                  <div className="flex items-center gap-3 text-cream-100" data-id="element-210">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gold-500/10 flex items-center justify-center text-gold-500" data-id="element-211">
                      <CheckIcon className="w-5 h-5" data-id="element-212" />
                    </div>
                    <span className="font-medium" data-id="element-213">
                      El eBook completo en PDF — documentado y estructurado
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-cream-100" data-id="element-214">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gold-500/10 flex items-center justify-center text-gold-500" data-id="element-215">
                      <CheckIcon className="w-5 h-5" data-id="element-216" />
                    </div>
                    <span className="font-medium" data-id="element-217">
                      El audiolibro completo en MP3 — para escuchar donde
                      quieras
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-cream-100" data-id="element-218">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gold-500/10 flex items-center justify-center text-gold-500" data-id="element-219">
                      <CheckIcon className="w-5 h-5" data-id="element-220" />
                    </div>
                    <span className="font-medium" data-id="element-221">
                      Acceso inmediato desde cualquier dispositivo
                    </span>
                  </div>
                </div>
              </div>

              {/* Right side: Price & Action */}
              <div className="md:col-span-2 p-6 md:p-12 bg-dark-900 flex flex-col items-center justify-center text-center relative overflow-hidden" data-id="element-222">
                {/* Background glow */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gold-500/5 blur-3xl rounded-full pointer-events-none" data-id="element-223" />

                <div className="relative z-10" data-id="element-224">
                  <div className="flex items-start justify-center text-gold-500 font-bold leading-none mb-6 md:mb-8" data-id="element-225">
                    <span className="text-3xl mt-2" data-id="element-226">$</span>
                    <span className="text-6xl" data-id="element-227">9.97</span>
                    <span className="text-dark-400 text-sm font-normal ml-2 mt-2" data-id="element-228">
                      USD
                    </span>
                  </div>

                  <motion.a href="https://instaflowdp.com/cart/62906407584113:1" target="_blank" rel="noopener noreferrer" onClick={() => {
                  if (window.fbq) {
                    window.fbq('track', 'InitiateCheckout', {
                      content_ids: ['62906407584113'],
                      content_type: 'product',
                      content_name: 'Minerales de Sangre eBook',
                      value: 9.97,
                      currency: 'USD'
                    });
                  }
                }} whileHover={{
                  scale: 1.02
                }} whileTap={{
                  scale: 0.98
                }} className="relative inline-flex items-center justify-center w-full px-8 py-4 text-lg font-bold tracking-wide transition-all duration-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark-900 shadow-lg shadow-red-500/20 mb-4 cursor-pointer" style={{
                  backgroundColor: '#dc2626',
                  color: '#ffffff',
                  fontSize: '14px'
                }} data-id="element-229">
                    OBTENER ACCESO INMEDIATO
                  </motion.a>

                  <p className="text-xs text-cream-400/60 flex items-center justify-center gap-1 mb-2" data-id="element-230">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-231">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-232"></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-233"></path>
                    </svg>
                    Pago seguro y encriptado
                  </p>
                  <p className="text-sm text-cream-300 font-medium" data-id="element-234">
                    eBook PDF + Audio MP3
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </Section>
    </div>;
}